import { useEffect, useState, useCallback } from 'react';

export const useReachScrollY = (y: number) => {
  const [reached, setReached] = useState<boolean>(false);

  const onScroll = useCallback(
    (ev: Event) => {
      const target = ev.target as HTMLDivElement;
      if (target !== document.body) return;
      const scrollY = Math.floor(target.scrollTop);
      setReached(scrollY >= y);
    },
    [reached, setReached]
  );

  useEffect(() => {
    window.addEventListener('scroll', onScroll, true);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return reached;
};
